// @flow
import * as React from "react";
import {useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";

import type {SourceType} from "./constants";
import {imageUrl} from "./constants";
// import imageUrl from "./constants/AP.png";
import sources from "./constants/sources.json";

// import "./ap_player.css";

let assetsRequestedRef = false;
const assetsMap = {
    cast_sender: false,
    video72: false,
    skin: false,
    chromecast: false,
};

type Props = {
    type: SourceType;
};

const ApVideoHubPortFull = ({type}: Props) => {
    const id = useMemo(() => `player-${type}`, [type]);

    const [assets, setAssets] = useState({
        cast_sender: false,
        video72: false,
        skin: false,
        chromecast: false,
    });
    const loadingAssets = useRef(false);
    const videoRef = useRef(null);
    const playerRef = useRef(null);

    const options = useMemo(() => ({
        autoplay: true,
        controls: true,
        muted: true,
        responsive: true,
        fluid: true,
        sources: [{
            src: sources.main[type],
            type: "application/x-mpegURL"
        }, {
            src: sources.reserve[type],
            type: "application/x-mpegURL"
        }]
    }), [type]);

    const assetsLoaded = useMemo(() => {
        let loaded = true;
        for (const assetLoaded of Object.values(assets)) {
            if (!assetLoaded) {
                loaded = false;
                break;
            }
        }
        return loaded;
    }, [assets]);

    useLayoutEffect(() => {
        if (!assetsRequestedRef) {
            assetsRequestedRef = true;
            loadingAssets.current = true;

            const cast_sender = document.createElement("script");
            cast_sender.src = "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
            cast_sender.async = true;
            cast_sender.onload = () => {
                assetsMap.cast_sender = true;
                setAssets(state => ({...state, cast_sender: true}));

                const video72 = document.createElement("script");
                // video72.src = "https://origin-cst-818.cdn.nextologies.com/videojs3/video.min.js";
                video72.src = "https://qa.nextologies.com/homenko/ap-video-hub/nuevo/video.min.js";
                video72.async = true;
                video72.onload = () => {
                    assetsMap.video72 = true;
                    setAssets(state => ({...state, video72: true}));

                    const skin = document.createElement("script");
                    // skin.src = "https://origin-cst-818.cdn.nextologies.com/videojs3/nuevo.min.js";
                    skin.src = "https://qa.nextologies.com/homenko/ap-video-hub/nuevo/nuevo.min.js";
                    skin.async = true;
                    skin.onload = () => {
                        assetsMap.skin = true;
                        setAssets(state => ({...state, skin: true}));

                        const chromecast = document.createElement("script");
                        // chromecast.src = "https://origin-cst-818.cdn.nextologies.com/videojs3/videojs-chromecast.min.js";
                        chromecast.src = "https://qa.nextologies.com/homenko/ap-video-hub/nuevo/videojs-chromecast.min.js";
                        chromecast.async = true;
                        chromecast.onload = () => {
                            assetsMap.chromecast = true;
                            setAssets(state => ({...state, chromecast: true}));
                        }
                        document.body.appendChild(chromecast);
                    }
                    document.body.appendChild(skin);
                }
                document.body.appendChild(video72);
            }
            document.body.appendChild(cast_sender);

            const videoJsStyles = document.createElement("link");
            // videoJsStyles.href = "https://origin-cst-818.cdn.nextologies.com/videojs3/videojs.min.css";
            videoJsStyles.href = "https://qa.nextologies.com/homenko/ap-video-hub/nuevo/videojs.min.css";
            videoJsStyles.rel = "stylesheet";
            document.body.appendChild(videoJsStyles);

            const apVideoJsStyles = document.createElement("link");
            apVideoJsStyles.href = "https://cstatic-801.cdn.nextologies.com/videojs3/ap_player.css";
            // this is due to local import "./ap_player.css";
            // apVideoJsStyles.href = "https://cstatic-801.cdn.nextologies.com/videojs32/ap_player.css";
            apVideoJsStyles.rel = "stylesheet";
            document.body.appendChild(apVideoJsStyles);
        }

        // Make sure Video.js player is only initialized once
        if (!playerRef.current && assetsLoaded) {
            const player = playerRef.current = window.videojs(id, options);
            player["nuevo"]({
                logooffsetX: 0,
                logooffsetY: 0,
                contextMenu: false,
                logotitle: "AP",
                logo: imageUrl,
                shareMenu: false,
                settingsButton: false,
            });
            setTimeout(() => {
                player.chromecast({button: "controlbar", metaTitle: "AP", metaSubtitle: "AP Live Choice"});
            }, 1000);

            player.on("error", function () {
                player.src({
                    src: sources.reserve[type],
                    type: "application/x-mpegURL"
                });
                player.play();
            });
            player.on("contenterror", function () {
                player.src({
                    src: sources.reserve[type],
                    type: "application/x-mpegURL"
                });
                player.play();
            });
        }
    }, [id, options, assets, assetsLoaded, type, videoRef]);

    useEffect(() => {
        if (assetsRequestedRef && !loadingAssets.current) {
            const intervalId = setInterval(() => {
                let loaded = true;
                for (const assetLoaded of Object.values(assetsMap)) {
                    if (!assetLoaded) {
                        loaded = false;
                        break;
                    }
                }
                if (loaded) {
                    clearInterval(intervalId);
                    setAssets({
                        cast_sender: true,
                        video72: true,
                        skin: true,
                        chromecast: true,
                    });
                } else {
                }
            }, 100);
        }
    }, [])

    // Dispose the Video.js player on unmounts
    useEffect(() => {
        return () => {
            const player = playerRef.current;
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, []);

    return (
        <div id={`wrapper-${id}`}>
            <video id={id} className="video-js vjs-fluid vjs-default-skin" preload="auto"/>
        </div>
    );
};

export default ApVideoHubPortFull;